import { Autocomplete } from '@features/common';
import { Cities } from '@features/customers/interfaces/search.interfaces';
import { DivisionEditionFormType } from '@features/divisions/interfaces/division-edition.interface';

import { AddGuidesRangeForm, AGWRangeHistoryCard } from '@features/ranges';
import useFirebase from '@hooks/firebase.hook';
import { ClienteSuite, DivisionCliente } from '@interfaces/firestore-documents.interfaces';
import { Button, Grid, Switch, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Controller, useFieldArray, UseFormReturn } from 'react-hook-form';
import { handleAddGuideRangeForm } from './DivisionEditionForm.handlers';

interface Props {
	form: UseFormReturn<DivisionEditionFormType>;
	nivelesServicio: number[];
	nit?: string;
	data: DivisionCliente;
	codigoDiv?: string;
	allData: ClienteSuite | null;
	cities: Cities[];
	getDataById: (identificacion: string) => Promise<void>;
}

const DivisionEditionForm: React.FC<Props> = ({
	form,
	nivelesServicio,
	cities,
	nit,
	data,
	codigoDiv,
	allData,
	getDataById,
}) => {
	const { control, setValue } = form;

	// States
	const [isAddGuidesRangeFormOpen, setIsAddGuidesRangeFormOpen] = useState<boolean>(false);

	// Hooks
	const agwRanges = useFieldArray({ control, name: 'agw_ranges' });

	const { combos } = useFirebase();

	useEffect(() => {
		setValue(
			'combos',
			data.combos.filter((i) => i.estado).map((i) => i.id_combo)
		);
	}, [data, setValue]);

	return (
		<>
			{isAddGuidesRangeFormOpen && (
				<AddGuidesRangeForm
					onClose={handleAddGuideRangeForm(false, setIsAddGuidesRangeFormOpen)}
					agw={true}
					allData={allData}
					getDataById={getDataById}
					showActual={false}
					nit={nit}
					codigoDiv={codigoDiv}
					cities={cities}
				/>
			)}
			<Typography color="#707070" fontFamily="Montserrat" fontSize={16} fontWeight={500}>
				Rango de guías y Consecutivo AGW
			</Typography>
			<Button
				fullWidth
				color="secondary"
				onClick={handleAddGuideRangeForm(true, setIsAddGuidesRangeFormOpen)}
				style={{
					borderColor: 'rgba(0, 0, 0, 0.12)',
					borderRadius: 4,
					boxShadow: '0px 3px 1px #00000033, 0px 2px 2px #00000024',
					color: '#686868',
					fontFamily: 'Montserrat',
					fontSize: 12,
					fontWeight: 'medium',
					height: 32,
					marginTop: 16,
					minWidth: 160,
					padding: '8px 24px',
					textTransform: 'none',
				}}
				variant="outlined"
			>
				Nuevo rango de guías
			</Button>
			{agwRanges.fields.map((range, index) => (
				<AGWRangeHistoryCard
					data={range}
					key={`division-edition-form-${range.id_rango}-${index}`}
					cities={cities}
					form={form}
					index={index}
					nit={nit != null ? nit : ''}
					codigoDiv={codigoDiv != null ? codigoDiv : ''}
				/>
			))}
			<Typography
				color="#707070"
				fontFamily="Montserrat"
				fontSize={14}
				fontWeight={600}
				style={{ marginTop: 24 }}
			>
				Combos
			</Typography>
			<Controller
				control={control}
				name="combos"
				render={({ field: { onChange, value } }) => {
					return (
						<Autocomplete
							getTooltipTitle={(value) =>
								combos[value]?.nombre_combo ?? 'Combo no registrado'
							}
							id="combo_option"
							options={Object.values(combos)
								.filter(
									(c) =>
										c.estado &&
										c.niveles_servicio
											.filter((ns) => ns.estado_sifa)
											.map((ns) => nivelesServicio.includes(ns.codigo_nivel))
											.every(Boolean)
								)
								.map((c) => Number(c.id_combo))}
							onChange={onChange}
							placeholder="Nuevo combo"
							style={{ marginTop: 8 }}
							value={value ?? []}
						/>
					);
				}}
			/>
			<Typography
				color="#707070"
				fontFamily="Montserrat"
				fontSize={14}
				fontWeight={600}
				style={{ marginTop: 24 }}
			>
				Notificaciones
			</Typography>
			<Grid container alignItems="center" justifyContent="space-between">
				<Grid item>
					<Typography
						color="#707070"
						fontFamily="Montserrat"
						fontSize={14}
						fontWeight="medium"
					>
						Notificación a remitente
					</Typography>
				</Grid>
				<Grid item>
					<Controller
						control={control}
						name="notificacion_remitente"
						render={({ field: { onChange, value } }) => (
							<Switch checked={value} onChange={onChange} />
						)}
					/>
				</Grid>
			</Grid>
			<Grid container alignItems="center" justifyContent="space-between">
				<Grid item>
					<Typography
						color="#707070"
						fontFamily="Montserrat"
						fontSize={14}
						fontWeight="medium"
					>
						Habilitar Retener Guía
					</Typography>
				</Grid>
				<Grid item>
					<Controller
						control={control}
						name="habilitado_retencion_guia"
						render={({ field: { onChange, value } }) => (
							<Switch checked={value} onChange={onChange} />
						)}
					/>
				</Grid>
			</Grid>
		</>
	);
};

export default DivisionEditionForm;
